export default {"src":"/_next/static/media/getsmarter-logo.393913b1.svg","height":48,"width":157,"blurWidth":0,"blurHeight":0};